export default __webpack_public_path__ + "static/media/YOOZ-PAYMENT-Gateway-banner.d524a22a.png";